import Scroll from "./components/Scroll.js";
import Header from "./components/Header.js";
import { api } from "./services/ApiService.js";
import PostsLoader from "./components/PostsLoader.js";
import Spollers from "./components/Spollers.js";
import PostsFilter from "./components/PostsFilter.js";
import SwiperSlider from "./components/SwiperSlider";
import HistoryTimeline from "./components/HistoryTimeline";
import Expandable from "./components/Expandable";
import TableOfContents from "./components/TableOfContents";
import FancyboxModule from "./components/Fancybox";
import FormVendors from "./components/forms/FormVendors.js";
import FormHandler from "./components/forms/FormHandler.js";
import FormCalcCost from "./components/forms/FormCalcCost.js";
import Animations from "./components/Animations.js";

/**
 * Main App function
 */
const AGDSApp = () => {
    // Start Loader
    window.addEventListener("load", () => {
        document.body.classList.add("_show");
    });

    // Options
    const options = {
        overlay: document.getElementById("overlay"),
        preloader: document.getElementById("preloader"),
        header: document.getElementById("header"),
        fancyEls: document.querySelectorAll("[data-fancybox]"),
        spollersEls: document.querySelectorAll("[data-spollers]"),
        postsContainer: document.getElementById("posts-container"),
        filterContainer: document.getElementById("posts-filter"),
        swiperEls: document.querySelectorAll(".swiper"),
        historyEls: document.querySelectorAll("[data-history]"),
        expandableEls: document.querySelectorAll("[data-expandable]"),
        formCalcCostEl: document.getElementById("form-calc-cost"),
        ajaxForms: document.querySelectorAll("form"),
    };

    // Scroll
    const scroll = document.body
        ? new Scroll({
              header: options.header,
          })
        : null;
    scroll?.init();

    // Header
    const header = options.header
        ? new Header({
              header: options.header,
          })
        : null;
    header?.init();

    // Fancybox
    const fancybox = options.fancyEls.length
        ? new FancyboxModule({
              fancyEls: options.fancyEls,
          })
        : null;
    fancybox?.init();

    // Spollers
    const spollers = options.spollersEls.length ? new Spollers() : null;
    spollers?.init();

    // PostLoader
    const postsLoader = options.postsContainer
        ? new PostsLoader({
              api: api,
              spollers: spollers,
              preloader: options.preloader,
              postsContainer: options.postsContainer,
          })
        : null;
    postsLoader?.init();

    // FilterPosts
    const postsFilter =
        postsLoader && options.filterContainer
            ? new PostsFilter({
                  api: api,
                  preloader: options.preloader,
                  spollers: spollers,
                  postsLoader: postsLoader,
                  postsContainer: options.postsContainer,
                  filterContainer: options.filterContainer,
              })
            : null;
    postsFilter?.init();

    // Swiper
    const swiper = options.swiperEls.length
        ? new SwiperSlider({
              swiperEls: options.swiperEls,
          })
        : null;
    swiper?.init();

    // HistoryTimeline
    const historyTimeline = options.historyEls.length
        ? new HistoryTimeline({
              blocks: options.historyEls,
          })
        : null;
    historyTimeline?.init();

    // Expandable
    const expandable = options.expandableEls.length
        ? new Expandable({
              elements: options.expandableEls,
          })
        : null;
    expandable?.init();

    // Table of contents
    const tableOfContents = new TableOfContents({
        contentSelector: ".post-content",
        tocSelector: ".table-of-contents",
        headingSelector: "h2",
        headerHeight: header?.headerHeightDetermination(),
    });
    tableOfContents?.init();

    // Form Vendors
    const formVendors = document.body ? new FormVendors() : null;
    formVendors?.init();

    // Forms
    const formHandler = options.ajaxForms.length ? new FormHandler(options.ajaxForms) : null;

    // Calc Cost
    const calcForm = options.formCalcCostEl
        ? new FormCalcCost({
              form: options.formCalcCostEl,
              formHandler,
          })
        : null;
    calcForm?.init();

    // Scroll-triggered section animations
    const animations = new Animations();
    animations.init();
};

// Start App
document.addEventListener("DOMContentLoaded", AGDSApp);
